import { ArrowUpDown, Filter, Layers, Search } from "lucide-react"

import { Input } from "@/components/ui/input"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface SearchFilterBarProps {
  search: string
  type: string
  status: string
  sort: string
  onSearchChange: (value: string) => void
  onTypeChange: (value: string) => void
  onStatusChange: (value: string) => void
  onSortChange: (value: string) => void
}

export function SearchFilterBar({
  search,
  type,
  status,
  sort,
  onSearchChange,
  onTypeChange,
  onStatusChange,
  onSortChange,
}: SearchFilterBarProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
      {/* Search Input */}
      <div className="relative flex-1">
        <Search className="text-muted-foreground absolute top-1/2 left-3 size-4 -translate-y-1/2" />
        <Input
          type="text"
          placeholder="Search flashcards..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9"
        />
      </div>

      {/* Filters - scroll horizontally on mobile */}
      <div className="flex items-center gap-2 overflow-x-auto pb-1 sm:pb-0">
        {/* Type Filter */}
        <Select value={type} onValueChange={onTypeChange}>
          <SelectTrigger size="sm" className="min-w-[100px] shrink-0">
            <Layers className="mr-1.5 size-3.5 shrink-0" />
            <SelectValue placeholder="Type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="phrase">Phrases</SelectItem>
            <SelectItem value="word">Words</SelectItem>
          </SelectContent>
        </Select>

        {/* Status Filter */}
        <Select value={status} onValueChange={onStatusChange}>
          <SelectTrigger size="sm" className="min-w-[110px] shrink-0">
            <Filter className="mr-1.5 size-3.5 shrink-0" />
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="due">Due Now</SelectItem>
            <SelectItem value="new">New</SelectItem>
            <SelectItem value="mastered">Mastered</SelectItem>
          </SelectContent>
        </Select>

        {/* Sort */}
        <Select value={sort} onValueChange={onSortChange}>
          <SelectTrigger size="sm" className="min-w-[120px] shrink-0">
            <ArrowUpDown className="mr-1.5 size-3.5 shrink-0" />
            <SelectValue placeholder="Sort" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="created_desc">Newest</SelectItem>
            <SelectItem value="created_asc">Oldest</SelectItem>
            <SelectItem value="next_review">Review Date</SelectItem>
            <SelectItem value="ease_asc">Hardest</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
